export default __webpack_public_path__ + "static/media/04.3c423ef7.jpg";